<template>
  <div class="account-statement__details">
    <el-tabs
      class="modify-el__tabs"
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane
        v-for="item in panel"
        :label="item.label"
        :name="item.name"
        :key="item.name"
        lazy
      >
      </el-tab-pane>
    </el-tabs>
    <TableComponent
      :pagination="pagination"
      @updateData="_updateData"
      :routeName="$route.name"
    >
      <template #default>
        <div class="btn-all">
          <Print
            :id="'table'"
            :header="$route.meta.title"
            :styles="{
              float: 'left',
              'padding-right': '1rem',
            }"
            v-permission:print="$route.meta.permission"
          >
            <el-button size="98">打印</el-button>
          </Print>
          <el-button
            size="98"
            class="d5"
            @click="exportAccountStatementDetails"
            v-permission:export="$route.meta.permission"
          >
            导出
          </el-button>
        </div>
        <div class="statement-details">
          <h3 class="title">
            {{ $route.query.title }}
          </h3>
          <p class="sub-title">对账单号：{{ $route.query.num }}</p>
          <div class="details">
            <div class="form-wrapper">
              <el-form label-position="right" label-width="auto" :model="info">
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    入驻商家：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.merchantName"
                      placeholder="请输入"
                      disabled
                      clearable
                    />
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    小程序名称：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.appletName"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    销售总金额：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.salesAmount"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    分润总金额：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.goodsAmount"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    提价总金额：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.diffAmount"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </el-form-item>
                <el-form-item
                  label="分润比例（完）："
                  :class="index !== 0 && 'none'"
                  v-for="(item, index) in info.taxRules"
                  :key="index"
                >
                  <div class="input-box">
                    <div class="input">
                      <el-input
                        placeholder="请输入"
                        v-model="item.startAmount"
                        type="number"
                        clearable
                        disabled
                      />
                    </div>
                    至
                    <div class="input">
                      <el-input
                        placeholder="请输入"
                        v-model="item.endAmount"
                        type="number"
                        clearable
                        disabled
                      />
                    </div>
                    <span class="name" style="margin-left: 2.8rem">比例：</span>
                    <div class="input">
                      <el-input
                        placeholder="请输入"
                        type="number"
                        v-model="item.commissionRatio"
                        clearable
                        disabled
                      />
                    </div>
                    %
                  </div>
                </el-form-item>
                <el-form-item
                  label="分润比例（跨）："
                  :class="index !== 0 && 'none'"
                  v-for="(item, index) in info.crossRules"
                  :key="-index - 1"
                >
                  <div class="input-box">
                    <div class="input">
                      <el-input
                        placeholder="请输入"
                        type="number"
                        v-model="item.startAmount"
                        clearable
                        disabled
                      />
                    </div>
                    至
                    <div class="input">
                      <el-input
                        placeholder="请输入"
                        type="number"
                        v-model="item.endAmount"
                        clearable
                        :disabled="$store.state.entryType !== 'admin'"
                      />
                    </div>
                    <span class="name" style="margin-left: 2.8rem">比例：</span>
                    <div class="input">
                      <el-input
                        placeholder="请输入"
                        type="number"
                        v-model="item.commissionRatio"
                        clearable
                        disabled
                      />
                    </div>
                    %
                  </div>
                </el-form-item>
              </el-form>
              <el-form label-position="right" label-width="auto" :model="info">
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    账单总订单数：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.orderNumber"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    账单总sku数量：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.skuNumber"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    分润收益金额：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.shareAmount"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    提价收益金额：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.raiseAmount"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    收益总金额：
                  </span>
                  <div class="input">
                    <el-input
                      v-model="info.incomeAmount"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="table" id="table">
          <el-table
            ref="table"
            :data="tableData"
            v-min-height
            :height="500"
            :header-cell-style="{
              background: 'transparent',
            }"
            border
            header-cell-class-name="theader-th__table"
            cell-class-name="tbody-td__table"
            class="no-hover no-pad__bor"
          >
            <el-table-column
              fixed
              label="商品标题"
              align="center"
              min-width="400"
              class-name="visible"
            >
              <div slot-scope="scope">
                <span class="top-bg" style="padding-left: 2rem">
                  订单号：{{ scope.row.orderNumber }}
                </span>
                <div class="order-details">
                  <div
                    :class="
                      scope.row.goodsList.length > 1 ? 'box bor-bottom' : 'box'
                    "
                    v-for="(item, index) in scope.row.goodsList"
                    :key="index"
                  >
                    <el-image :src="item.imgUrl" class="goods-img">
                      <div slot="error" class="image-slot">
                        <i class="iconfont icon-tupian" />
                      </div>
                    </el-image>
                    <div class="caption">
                      <p class="ellipses">
                        <el-tooltip
                          effect="light"
                          placement="bottom-start"
                          :content="item.cnName"
                        >
                          <span class="goods-name"> {{ item.cnName }}</span>
                        </el-tooltip>
                      </p>
                      <p class="ellipses">
                        <el-tooltip
                          effect="light"
                          placement="bottom-start"
                          :content="item.enName"
                        >
                          <span class="goods-name"> {{ item.enName }}</span>
                        </el-tooltip>
                      </p>
                      <p class="ellipses">
                        <el-tooltip
                          effect="light"
                          placement="bottom-start"
                          :content="item.sku"
                        >
                          <span class="goods-name"
                            >SKU编码：{{ item.sku }}</span
                          >
                        </el-tooltip>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="单价（元)" min-width="180">
              <div slot-scope="scope">
                <span class="top-bg"></span>
                <div class="order-details">
                  <div
                    :class="
                      scope.row.goodsList.length > 1
                        ? 'set-height bor-bottom'
                        : 'box'
                    "
                    v-for="(item, index) in scope.row.goodsList"
                    :key="index"
                  >
                    {{ item.price | formatMoney }}
                  </div>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="数量" min-width="180">
              <div slot-scope="scope">
                <span class="top-bg"></span>
                <div class="order-details">
                  <div
                    :class="
                      scope.row.goodsList.length > 1
                        ? 'set-height bor-bottom bor-right'
                        : 'box'
                    "
                    v-for="(item, index) in scope.row.goodsList"
                    :key="index"
                  >
                    {{ item.num }}
                  </div>
                </div>
              </div>
            </el-table-column>
            <el-table-column
              align="center"
              label="订单归属商家"
              min-width="180"
            >
              <div slot-scope="scope">
                <span class="top-bg"></span>
                <div class="order-details">
                  {{ scope.row.appName }}
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="订单金额" min-width="180">
              <div slot-scope="scope">
                <span class="top-bg">
                  <div class="order-time">
                    下单时间：{{ scope.row.orderTime }}
                  </div>
                </span>
                <div class="order-details">
                  <p class="money">
                    {{ scope.row.orderAmount | formatMoney }}
                  </p>
                  <p>运费：{{ scope.row.shipping }}</p>
                  <p>
                    <i class="iconfont icon-weixin"></i>
                    {{ scope.row.paymentType }}
                  </p>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="订单来源" min-width="180">
              <div slot-scope="scope">
                <span class="top-bg" />
                <div
                  class="order-details"
                  v-orderSource="{
                    source: scope.row.orderSource,
                    state: scope.row.orderType,
                  }"
                />
              </div>
            </el-table-column>
            <el-table-column align="center" label="订单状态" min-width="180">
              <div slot-scope="scope">
                <span class="top-bg">
                  <div class="order-time">
                    付款时间：{{ scope.row.payTime }}
                  </div>
                </span>
                <div class="order-details">
                  {{ scope.row.orderState | formatOrderStatus }}
                </div>
              </div>
            </el-table-column>
            <el-table-column
              align="center"
              label="退单类型"
              min-width="180"
              v-if="$route.query.type === 2"
            >
              <div slot-scope="scope">
                <span class="top-bg" />
                <div class="order-details">
                  {{ scope.row.refundType | formatOrderStatus }}
                </div>
              </div>
            </el-table-column>
            <el-table-column
              align="center"
              label="退款金额"
              min-width="180"
              v-if="$route.query.type === 2"
            >
              <div slot-scope="scope">
                <span class="top-bg" />
                <div class="order-details">
                  {{ scope.row.refundAmount | formatMoney }}
                </div>
              </div>
            </el-table-column>
            <el-table-column
              align="center"
              label="对账状态"
              min-width="180"
              fixed="right"
            >
              <div slot-scope="scope">
                <span class="top-bg" />
                <div class="order-details">
                  {{ +scope.row.bill > 0 ? '已对账' : '未对账' }}
                </div>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </TableComponent>
  </div>
</template>
<script>
import Print from 'components/Print/'
import TableComponent from '../../Components/TableComponent'
import tabsIndex from 'mixins/tabsIndex'
import updateData from 'mixins/updateData'

export default {
  name: 'accountStatementDetails',
  mixins: [tabsIndex, updateData],
  components: {
    Print,
    TableComponent,
  },
  data() {
    this.panel = [
      {
        label: '跨境',
        name: '2',
      },
      {
        label: '完税',
        name: '1',
      },
    ]
    this.keyMap = {
      bill_info: {
        name: 'info',
        bill_id: 'id',
        reconciler: 'operator',
        bill_no: 'singleNumber',
        bill_name: 'statementName',
        bill_source: 'source',
        bill_status: 'status',
        statement_time: 'time',
        applet_id: 'appletId',
        app_name: 'appletName',
        merchant_id: 'merchantId',
        merchant_name: 'merchantName',
        duty_order_number: 'taxOrderNumber',
        cross_order_number: 'crossOrderNumber',
        duty_order_amount: 'taxSalesAmount',
        cross_order_amount: 'crossSalesAmount',
        duty_order_tariff: 'taxTariffAmount',
        cross_order_tariff: 'crossTariffAmount',
        duty_sku_number: 'taxSkuNumber',
        cross_sku_number: 'crossSkuNumber',
        duty_goods_price: 'taxDeclareAmount',
        cross_goods_price: 'crossDeclareAmount',
        duty_diff_price: 'taxRaiseAmount',
        cross_diff_price: 'crossRaiseAmount',
        duty_diff_tariff: 'taxRaiseTariffAmount',
        cross_diff_tariff: 'crossRaiseTariffAmount',
        merchant_remarks: 'merchantRemarks',
        platform_remarks: 'platformRemarks',
        cross_share_rules: 'crossRules',
        duty_share_rules: 'taxRules',
        sales_end_amount: 'endAmount',
        sales_start_amount: 'startAmount',
        commission_rate: 'commissionRatio',
        rule_id: 'ruleId',
        royalty_type: 'royaltyType',
        order_number: 'orderNumber',
        order_amount: 'salesAmount',
        sku_number: 'skuNumber',
        diff_price: 'diffAmount',
        goods_price: 'goodsAmount',
        sharing_amount: 'shareAmount',
        diff_amount: 'raiseAmount',
        income_amount: 'incomeAmount',
      },
      order_list: {
        name: 'tableData',
        app_name: 'appName',
        member_name: 'account',
        payment_status: 'payType',
        order_state: 'orderState',
        order_source: 'orderSource',
        order_type: 'orderType',
        payment_code: 'paymentType',
        pay_sn: 'orderNumber',
        goods_list: 'goodsList',
        goods_image: 'imgUrl',
        goods_name: 'cnName',
        goods_en: 'enName',
        goods_sku: 'sku',
        goods_price: 'price',
        goods_num: 'num',
        order_amount: 'orderAmount',
        shipping_fee: 'shipping',
        refund_type: 'refundType',
        refund_amount: 'refundAmount',
        bill_id: 'bill',
        add_time: 'orderTime',
        payment_time: 'payTime',
      },
    }
    return {
      info: {
        amount: [],
      },
      activeName: '2',
      tableData: [],
      pagination: {
        currentPage: 1,
        recordTotal: -1,
        pageTotal: -1,
      },
    }
  },
  watch: {
    $route: {
      handler(to) {
        const id = to.query.id
        if (id) {
          this._getAccountStatementDetails({
            bill_id: id,
          })
          this._getAccountStatementOrder({
            curpage: 1,
            reconciliation_status: 2,
            bill_id: id,
            order_type: this.activeName,
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 标签页切换
     * @param tab
     * @param event
     */
    handleClick(tab, event) {
      this._getAccountStatementOrder({
        curpage: 1,
        reconciliation_status: 2,
        bill_id: this.$route.query.id,
        order_type: this.activeName,
      })
      this._tabsRecord()
    },
    /**
     * 获取对账单详情
     * @param params
     * @private
     */
    _getAccountStatementDetails(params) {
      this.api.getAccountStatementDetails(params).then((res) => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.info = res.info
      })
    },
    /**
     * 获取对账单订单
     * @param params
     * @private
     */
    _getAccountStatementOrder(params) {
      this.api.getFinanceOrderList(params).then((res) => {
        this.utils.setCommonCode(res, this)
      })
    },
    /**
     * 导出对账单详情
     */
    exportAccountStatementDetails() {
      this.api
        .exportAccountStatementDetails({
          bill_id: this.$route.query.id,
        })
        .then((res) => {
          const blob = new Blob([res], {
            type: 'application/vnd.ms-excel',
          })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) //建立下载的连接
          downloadElement.href = href
          downloadElement.download = `${this.$route.query.title}.xlsx` //下载后文件名
          document.body.appendChild(downloadElement)
          downloadElement.click() //点击下载
          document.body.removeChild(downloadElement) //下载完成移除元素
          window.URL.revokeObjectURL(href) //释放掉blob对象
        })
    },
  },
}
</script>
<style lang="scss">
.account-statement__details {
  .statement-details {
    color: colors('60');
    text-align: center;

    .title {
      font-size: 2rem;
    }

    .sub-title {
      margin-bottom: 5.3rem;
    }

    .details {
      position: relative;
      width: 100%;
      text-align: left;
      padding: 0 3.4rem;
      line-height: 1.3rem;

      .form-wrapper {
        display: flex;
        justify-content: space-evenly;
      }

      .input {
        margin-bottom: 5px;
      }

      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        border-bottom: 1px dashed colors('bor-main');
        margin: 1.3rem 0 3.8rem 0;
      }
    }
  }
}
</style>
